module.exports = __webpack_public_path__ + "img/shoppingcart-blue.a7fa5b64.png";